const initialState = {
    objectId: '9423E14C-E4BF-452C-A167-6FB7C3634101',
    selectedLanguage: false,
    object: null,
    objectList: {},
    mediaProgress: {
        progress: 0,
        duration: 0,
        position: 0
    },
    isPlaying: false,
    parameters : {
        textMode: false,
        currentAvatarId: null
    }
};


export const reducer = (state = initialState, action) => {
    const {type, value} = action;

    switch (type) {
        case 'OBJECT_LIST_UPDATE':
            return {
                ...state,
                objectList: value
            };

        case 'OBJECT_UPDATE':
            return {
                ...state,
                object: value
            };

        case 'LANGUAGE_SWITCH':
            return {
                ...state,
                selectedLanguage: value
            };

        case 'OBJECT_SWITCH':
            return {
                ...state,
                objectId: value
            };

        case 'CHANGE_PROGRESS':
            return {
                ...state,
                mediaProgress: value
            };

        case 'CHANGE_PLAYING':
            return {
                ...state,
                isPlaying: value
            };

        case 'SET_PARAMETERS':
            return {
                ...state,
                parameters: value
            };

        default:
            return state;
    }


};